export default "__VITE_ASSET__CbqHs03T__"